import React from 'react';
import Navbar from '../../components/Navbar/Navbar';

const OurPortfolio = () => {
    return (
        <>
            <Navbar></Navbar>
            <div className="container my-5 py-5">
            <h1>Portfolio coming soon...</h1>
            </div>
        </>
    );
};

export default OurPortfolio;